import React from "react";
import { ICommonIconProps } from "../interface";

const CloseIcon = ({ ...props }: ICommonIconProps) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6116 4.38891C19.7589 -1.4626 10.2407 -1.4626 4.38791 4.38891C-1.46231 10.2404 -1.46231 19.7611 4.38791 25.6126C7.31428 28.5378 11.1573 29.9996 15.0004 29.9996C18.8435 29.9996 22.6852 28.5377 25.6116 25.6126C31.4631 19.7612 31.4631 10.2404 25.6116 4.38891ZM21.1895 19.4222C21.6785 19.9112 21.6785 20.7016 21.1895 21.1905C21.0735 21.3068 20.9357 21.399 20.784 21.4619C20.6322 21.5248 20.4696 21.5571 20.3053 21.557C20.1411 21.5571 19.9784 21.5248 19.8267 21.4619C19.675 21.399 19.5371 21.3068 19.4212 21.1905L15.0003 16.7684L10.5808 21.1892C10.3462 21.4237 10.0282 21.5555 9.69659 21.5557C9.53234 21.5558 9.36968 21.5235 9.21795 21.4606C9.06622 21.3977 8.9284 21.3055 8.81241 21.1892C8.32345 20.7003 8.32345 19.9086 8.81241 19.4209L13.232 15.0001L8.81117 10.5793C8.32222 10.0904 8.32222 9.29873 8.81117 8.81101C9.2989 8.32205 10.0905 8.32205 10.5795 8.81101L15.0003 13.2318L19.4211 8.81101C19.9101 8.32205 20.7004 8.32205 21.1894 8.81101C21.6784 9.29873 21.6784 10.0904 21.1894 10.5793L16.7686 15.0001L21.1895 19.4222Z"
        fill={props?.IconColor || "currentColor"}
      />
    </svg>
  );
};

export default CloseIcon;
